<template>
  <v-app>
    <v-main>
      <div
        id="calculator"
        style="
          width: 1306px;
          height: 1009px;
          border: none;
          font-family: Pingfang SC, sans-serif;
        "
        v-if="windowWidth > 768"
      >
        <v-row no-gutters>
          <v-col cols="6">
            <v-card
              color="white"
              height="100%"
              style="
                padding: 78px 101px 0px 50px;
                border-radius: 0;
                font-family: Pingfang SC, sans-serif;
              "
              flat
            >
              <v-card-title
                class="mb-5"
                style="padding: 0; font-size: 24px; font-weight: 500"
              >
                <div style="font-family: Pingfang SC, sans-serif">
                  {{ isEnglish ? "Where are you heading to?" : "您的目的地是哪里？" }}
                </div></v-card-title
              >

              <v-combobox
                v-model="selectedItem"
                :items="filteredItems"
                :placeholder="defaultText"
                default
                outlined
                v-if="true"
                :search-input.sync="search"
                item-text="name"
                item-value="id"
                color="#8E59FF"
                :filter="customFilter"
                :readonly="filteredItems.length == 0 && !search"
                item-color="#F4EEFF"
              >
                <template v-slot:append>
                  <img src="@/assets/dropdownChevron.svg" class="mr-2" />
                </template>

                <template v-slot:item="{ item }">
                  <v-list-item-group v-model="selectedItem">
                    <div :disabled="item.disabled" :value="item">
                      <div v-if="item.code == 'divider'">
                        <v-chip
                          color="#F5F7FA"
                          text-color="#8E59FF"
                          style="font-weight: 600"
                          size="x-large"
                          class=""
                          height="26"
                          >{{ isEnglish ? "Regional" : "本地流量" }}</v-chip
                        >
                      </div>
                      <div v-else-if="item.code == 'prepend' && search">
                        <v-chip
                          color="#F5F7FA"
                          text-color="#8E59FF"
                          style="font-weight: 600"
                          size="x-large"
                          class=""
                          height="26"
                          >{{ isEnglish ? "Local" : "区域流量" }}</v-chip
                        >
                      </div>
                      <div v-else-if="item.code == 'prepend' && !search">
                        <v-chip
                          color="#F5F7FA"
                          text-color="#8E59FF"
                          style="font-weight: 600; font-family: Pingfang SC, sans-serif"
                          size="x-large"
                          class=""
                          height="26"
                          >{{ isEnglish ? "Popular Destinations" : "热门目的地" }}</v-chip
                        >
                      </div>
                      <div
                        v-else
                        class="d-flex flex-row align-item-center"
                        style="width: 450px"
                      >
                        <v-list-item-title class="d-block" style="flex: none">{{
                          item.name
                        }}</v-list-item-title>
                        <div v-if="item.sale">
                          <v-chip
                            color="red"
                            text-color="white"
                            style="
                              font-size: 10px;
                              font-weight: 500;
                              padding-left: 10px;
                              padding-right: 10px;
                              line-height: 150%;
                              height: 17px;
                            "
                            class="ml-4"
                          >
                            <span>{{ isEnglish ? "Sale" : "折扣" }}</span>
                          </v-chip>
                        </div>
                        <img
                          v-if="!item.countryTotal"
                          :src="getFlagUrl(item.code)"
                          loading="lazy"
                          class=""
                          style="width: 30px; margin-left: auto; border-radius: 4px"
                        />
                        <span
                          v-if="item.countryTotal"
                          class="gray--text"
                          style="
                            margin-left: auto;
                            font-size: 14px;
                            font-weight: 500;
                            color: #909399;
                          "
                          >{{ item.countryTotal }}
                          {{ isEnglish ? "Destinations" : "个目的地" }}
                        </span>
                      </div>
                    </div>
                  </v-list-item-group>
                </template>

                <template v-slot:no-data>
                  <v-list-item-group class="ml-3">{{
                    isEnglish
                      ? `No options found for "${search}" .`
                      : "找不到该目的地，请再试一次。"
                  }}</v-list-item-group>
                </template>
              </v-combobox>
              <hr color="#F4F4F5" class="mb-7" />
              <v-card-title
                class="mb-5 d-flex flex-row justify-space-between"
                style="padding: 0; font-size: 24px; font-weight: 500"
              >
                <div style="font-family: Pingfang SC, sans-serif">
                  {{ isEnglish ? "Activities usage" : "活动用量" }}
                </div>
                <v-chip
                  color="#F2FBFF"
                  text-color="#00A9F3"
                  style="font-family: Pingfang SC, sans-serif"
                >
                  {{ isEnglish ? "Daily" : "按天计算" }}
                </v-chip>
              </v-card-title>
              <v-row style="font-size: 18px; font-weight: 500">
                <v-col
                  v-for="item in activities"
                  :key="item.key"
                  cols="12"
                  class="d-flex flex-row align-center mb-6"
                >
                  <img :src="getImgUrl(item.iconSrc)" class="mr-3" />
                  <div style="font-family: Pingfang SC, sans-serif">{{ item.name }}</div>
                  <div class="ml-auto text-subtitle-1 d-flex flex-row align-center">
                    <img
                      src="@/assets/minusActive.svg"
                      class="mr-3"
                      v-if="
                        item.hours > 0 && typeof selectedItem === 'object' && selectedItem
                      "
                      style="cursor: pointer"
                      @click="decHrs(item.key)"
                    />
                    <img src="@/assets/minusInactive.svg" class="mr-3" v-else />
                    <div
                      style="
                        width: 70px;
                        text-align: center;
                        font-family: Pingfang SC, sans-serif;
                      "
                    >
                      {{ item.hours }}
                      {{ isEnglish ? "hrs" : "小时" }}
                    </div>
                    <img
                      src="@/assets/plusActive.svg"
                      class="ml-3"
                      v-if="
                        item.hours < 24 &&
                        typeof selectedItem === 'object' &&
                        selectedItem
                      "
                      style="cursor: pointer"
                      @click="incHrs(item.key)"
                    />
                    <img src="@/assets/plusInactive.svg" class="ml-3" v-else />
                  </div>
                </v-col>

                <v-col cols="12">
                  <v-btn
                    :color="buttonEnable ? '#8E59FF' : '#C7C9CC'"
                    width="100%"
                    height="60px"
                    variant="flat"
                    @click="calcData"
                    :disabled="!buttonEnable"
                  >
                    <div style="color: white">
                      {{ isEnglish ? "Calculate" : "计算" }}
                    </div>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-card
              color="#4F3FAC"
              height="100%"
              style="padding: 78px 75px 0px 75px; color: white; border-radius: 0"
            >
              <v-card-title
                class="mb-5"
                style="padding: 0; font-size: 24px; font-weight: 500"
              >
                <div>
                  {{ isEnglish ? "Estimated data usage" : "预估使用流量" }}
                </div></v-card-title
              >

              <v-row justify="space-between">
                <v-col cols="3" align="left">
                  <div style="display: inline-block" align="left">
                    <div class="mb-3 pa-0" style="font-size: 16px; font-weight: 500">
                      {{ isEnglish ? "1 Day" : "1天" }}
                    </div>

                    <div style="font-size: 24px; font-weight: 600">
                      {{ dailyData.toFixed(2) }} GB
                    </div>
                  </div>
                </v-col>
                <v-col cols="6" align="center">
                  <div
                    style="
                      width: 85%;
                      border-right: 2px solid grey;
                      border-left: 2px solid grey;
                    "
                  >
                    <div style="display: inline-block" align="left">
                      <div class="mb-3 pa-0" style="font-size: 16px; font-weight: 500">
                        {{ isEnglish ? "7 Days" : "7天" }}
                      </div>
                      <div style="font-size: 24px; font-weight: 600">
                        {{ weeklyData.toFixed(2) }} GB
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="3" align="right">
                  <div style="display: inline-block" align="left">
                    <div class="mb-3 pa-0" style="font-size: 16px; font-weight: 500">
                      {{ isEnglish ? "30 Days" : "30天" }}
                    </div>
                    <div style="font-size: 24px; font-weight: 600">
                      {{ monthlyData.toFixed(2) }} GB
                    </div>
                  </div>
                </v-col>
              </v-row>
              <hr class="mt-6" color="grey" />
              <div
                style="width: 354px; margin: auto; margin-top: 221px; text-align: center"
                class="d-flex flex-column align-center justify-center"
                v-if="!calculated"
              >
                <img src="@/assets/calculator.svg" class="mb-5" />
                <div style="font-size: 24px; font-weight: 500">
                  {{
                    isEnglish
                      ? "Please select estimate usage from the list on the left for calculation."
                      : "从左侧列表中选择对应的活动用量，轻松了解您的流量使用情况！"
                  }}
                </div>
              </div>
              <div
                v-if="calculated"
                style="
                  overflow-y: auto;
                  height: 710px;
                  position: relative;
                  border-radius: 0;
                  justify-content: left;
                  display: inline-block;
                  width: 502px;
                "
              >
                <v-card-title class="pa-0 mx-0 mb-4 mt-4">
                  {{ isEnglish ? "Suggested eSIM data plans" : "最适合您的eSIM流量套餐" }}
                </v-card-title>

                <div
                  style="
                    overflow-y: auto;
                    height: 566px;
                    width: 500px;
                    padding-right: 16px;
                  "
                >
                  <v-card
                    v-for="product in productList"
                    :key="product.id"
                    class="mx-auto rounded-lg d-flex flex-row align-center pa-6 mb-8"
                    height="104"
                    @click="onClick(product)"
                    :style="
                      product.data == 5 && product.code && !leavingPage
                        ? 'border: 3px solid #80d4fc;'
                        : 'border: none;'
                    "
                    id="results"
                  >
                    <img :src="getFlagUrl(product.code)" class="mr-5 rounded-0" />
                    <div class="d-flex flex-column">
                      <div class="pa-0 ma-0" style="font-size: 20px; font-weight: 500">
                        {{ product.data }} GB/{{ product.days }}
                        {{ isEnglish ? "Days" : "天" }}

                        <v-chip
                          v-if="product.data == 5 && !product.sale && product.code"
                          class="ml-3"
                          color="orange"
                          text-color="white"
                          size="x-large"
                          style="height: 23px; padding-left: 18px; padding-right: 18px"
                        >
                          {{ isEnglish ? "Best Value" : "热销中" }}
                        </v-chip>
                        <v-chip
                          v-else-if="product.sale"
                          color="red"
                          text-color="white"
                          style="
                            font-size: 10px;
                            font-weight: 500;
                            padding-left: 10px;
                            padding-right: 10px;
                            line-height: 150%;
                            height: 17px;
                          "
                          class="ml-4"
                        >
                          <span>
                            {{ isEnglish ? "Sale" : "折扣" }}
                            Sale</span
                          >
                        </v-chip>
                      </div>
                      <v-card-text class="pa-0 ma-0" v-if="product.code"
                        >{{ product.name }}
                        {{ isEnglish ? "data" : "流量" }}
                      </v-card-text>
                      <v-card-text class="pa-0 ma-0" v-else
                        >{{ product.name }}
                        {{ isEnglish ? "data" : "流量" }}
                        ·
                        {{ product.dests }}
                        {{ isEnglish ? "destinations" : "个目的地" }}
                      </v-card-text>
                    </div>
                    <div
                      style="margin-left: auto; text-align: right"
                      class="d-flex flex-column"
                    >
                      <div
                        class="pa-0 ma-0"
                        style="font-size: 20px; font-weight: 500"
                        v-if="!product.discount"
                      >
                        ${{
                          product.price % 1 === 0 ? product.price + ".00" : product.price
                        }}
                      </div>
                      <div v-else>
                        <div class="pa-0 ma-0" style="font-size: 20px; font-weight: 500">
                          ${{
                            product.discount % 1 === 0
                              ? product.discount + ".00"
                              : product.discount
                          }}
                        </div>
                        <v-card-text class="pa-0 ma-0">
                          <s
                            >${{
                              product.price % 1 === 0
                                ? product.price + ".00"
                                : product.price
                            }}
                          </s></v-card-text
                        >
                      </div>
                    </div>
                    <img src="@/assets/rightArrow.svg" class="ml-4" />
                  </v-card>
                </div>
                <div
                  style="
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    font-size: 16px;
                    font-weight: 600;
                    align-items: center;
                    display: flex;
                    flex-direction: row;
                    cursor: pointer;
                    font-family: Nunito;
                  "
                  @click="onClick()"
                >
                  {{
                    isEnglish ? "Explore more eSIM data plans" : "探索更多eSIM流量套餐"
                  }}

                  <img src="@/assets/rightArrowWhite.svg" />
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <div v-else>
        <v-card
          color="white"
          style="padding: 35px 16px 0px 16px; font-family: Pingfang SC, sans-serif"
        >
          <v-card-title
            class="mb-5"
            style="padding: 0; font-size: 16px; font-weight: 600"
          >
            <div
              style="
                font-family: Pingfang SC, sans-serif;
                font-size: 16px;
                font-weight: 600;
              "
            >
              {{ isEnglish ? "Where are you heading to?" : "您的目的地是哪里？" }}
            </div></v-card-title
          >

          <v-combobox
            v-model="selectedItem"
            :items="filteredItems"
            :placeholder="defaultText"
            default
            outlined
            :search-input.sync="search"
            item-text="name"
            item-value="id"
            color="#8E59FF"
            :readonly="filteredItems.length == 0 && !search"
            :filter="customFilter"
            item-color="#F4EEFF"
          >
            <template v-slot:append>
              <img src="@/assets/dropdownChevron.svg" class="mr-2" />
            </template>

            <template v-slot:item="{ item }">
              <v-list-item-group v-model="selectedItem">
                <div :disabled="item.disabled" :value="item">
                  <div v-if="item.code == 'divider'">
                    <v-chip
                      color="#F5F7FA"
                      text-color="#8E59FF"
                      style="font-weight: 600"
                      size="x-large"
                      class=""
                      height="26"
                    >
                      {{ isEnglish ? "Regional" : "本地流量" }}
                    </v-chip>
                  </div>
                  <div v-else-if="item.code == 'prepend'">
                    <v-chip
                      color="#F5F7FA"
                      text-color="#8E59FF"
                      style="font-weight: 600"
                      size="x-large"
                      class=""
                      height="26"
                    >
                      {{ isEnglish ? "Local" : "区域流量" }}
                    </v-chip>
                  </div>
                  <div
                    v-else
                    class="d-flex flex-row align-item-center"
                    style="width: 285px"
                  >
                    <v-list-item-title class="d-block" style="flex: none">{{
                      item.name
                    }}</v-list-item-title>
                    <div v-if="item.sale">
                      <v-chip
                        color="red"
                        text-color="white"
                        style="
                          font-size: 10px;
                          font-weight: 500;
                          padding-left: 10px;
                          padding-right: 10px;
                          line-height: 150%;
                          height: 17px;
                        "
                        class="ml-4"
                      >
                        <span>
                          {{ isEnglish ? "Sale" : "折扣" }}
                        </span>
                      </v-chip>
                    </div>
                    <img
                      v-if="!item.countryTotal"
                      :src="getFlagUrl(item.code)"
                      loading="lazy"
                      class=""
                      style="width: 30px; margin-left: auto; border-radius: 4px"
                    />
                    <span
                      v-if="item.countryTotal"
                      class="gray--text"
                      style="
                        margin-left: auto;
                        font-size: 14px;
                        font-weight: 500;
                        color: #909399;
                      "
                      >{{ item.countryTotal }}
                      {{ isEnglish ? "Destinations" : "个目的地" }}
                    </span>
                  </div>
                </div>
              </v-list-item-group>
            </template>

            <template v-slot:no-data>
              <v-list-item-group class="ml-3">
                {{
                  isEnglish
                    ? `No options found for "${search}" .`
                    : "找不到该目的地，请再试一次。"
                }}
              </v-list-item-group>
            </template>
          </v-combobox>
          <hr color="#F4F4F5" class="mb-7" />
          <v-card-title
            class="mb-5 d-flex flex-row justify-space-between"
            style="padding: 0; font-size: 16px; font-weight: 600"
          >
            <div
              style="
                font-family: Pingfang SC, sans-serif;
                font-size: 16px;
                font-weight: 600;
              "
            >
              {{ isEnglish ? "Activities usage" : "活动用量" }}
            </div>
            <v-chip
              color="#F2FBFF"
              text-color="#00A9F3"
              style="
                font-family: Pingfang SC, sans-serif;
                font-size: 13px;
                font-weight: 500;
              "
            >
              {{ isEnglish ? "Daily" : "按天计算" }}
            </v-chip>
          </v-card-title>
          <v-row style="font-size: 13px; font-weight: 500">
            <v-col
              v-for="item in activities"
              :key="item.key"
              cols="12"
              class="d-flex flex-row align-center mb-6"
            >
              <img :src="getImgUrl(item.iconSrc)" class="mr-3" />
              <div
                style="
                  font-family: Pingfang SC, sans-serif;
                  font-size: 13px;
                  font-weight: 500;
                "
              >
                {{ item.name }}
              </div>
              <div class="ml-auto text-subtitle-1 d-flex flex-row align-center">
                <img
                  src="@/assets/minusActive.svg"
                  class="mr-3"
                  v-if="
                    item.hours > 0 && typeof selectedItem === 'object' && selectedItem
                  "
                  style="cursor: pointer"
                  @click="decHrs(item.key)"
                />
                <img src="@/assets/minusInactive.svg" class="mr-3" v-else />
                <div
                  style="
                    width: 55px;
                    text-align: center;
                    font-family: Pingfang SC, sans-serif;
                    font-size: 13px;
                    font-weight: 500;
                  "
                >
                  {{ item.hours }}
                  {{ isEnglish ? "hrs" : "小时" }}
                </div>
                <img
                  src="@/assets/plusActive.svg"
                  class="ml-3"
                  v-if="
                    item.hours < 24 && typeof selectedItem === 'object' && selectedItem
                  "
                  style="cursor: pointer"
                  @click="incHrs(item.key)"
                />
                <img src="@/assets/plusInactive.svg" class="ml-3" v-else />
              </div>
            </v-col>

            <v-col cols="12">
              <v-btn
                :color="buttonEnable ? '#8E59FF' : '#C7C9CC'"
                width="100%"
                height="60px"
                variant="flat"
                @click="calcData"
                :disabled="!buttonEnable"
                class="mb-8"
              >
                <div style="color: white">
                  {{ isEnglish ? "Calculate" : "计算" }}
                </div>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          color="#4F3FAC"
          height="100%"
          style="padding: 23px 16px 28px 16px; color: white; border-radius: 0"
          flat
        >
          <v-card-title
            class="mb-5"
            style="padding: 0; font-size: 16px; font-weight: 600"
          >
            <div
              style="
                font-size: 16px;
                font-family: Pingfang SC, sans-serif;
                font-weight: 600;
              "
            >
              {{ isEnglish ? "Estimated data usage" : "预估使用流量" }}
            </div></v-card-title
          >

          <v-row justify="space-between">
            <v-col cols="3" align="left">
              <div style="display: inline-block" align="left">
                <div class="mb-3 pa-0" style="font-size: 12px">
                  {{ isEnglish ? "1 Day" : "1天" }}
                </div>

                <div style="font-size: 16px">{{ dailyData.toFixed(2) }} GB</div>
              </div>
            </v-col>
            <v-col cols="6" align="center">
              <div
                style="
                  width: 85%;
                  border-right: 2px solid grey;
                  border-left: 2px solid grey;
                "
              >
                <div style="display: inline-block" align="left">
                  <div class="mb-3 pa-0" style="font-size: 12px">
                    {{ isEnglish ? "7 Days" : "7天" }}
                  </div>
                  <div style="font-size: 16px">{{ weeklyData.toFixed(2) }} GB</div>
                </div>
              </div>
            </v-col>
            <v-col cols="3" align="right">
              <div style="display: inline-block" align="left">
                <div class="mb-3 pa-0" style="font-size: 12px">
                  {{ isEnglish ? "30 Days" : "30天" }}
                </div>
                <div style="font-size: 16px">{{ monthlyData.toFixed(2) }} GB</div>
              </div>
            </v-col>
          </v-row>
          <hr class="mt-6" color="grey" />
          <div
            style="
              width: 354px;
              margin: auto;
              margin-top: 70px;
              text-align: center;
              padding-left: 37px;
              padding-right: 60px;
              padding-bottom: 100px;
            "
            class="d-flex flex-column align-center justify-center"
            v-if="!calculated"
          >
            <img src="@/assets/calculator.svg" class="mb-5" />
            <div style="font-size: 14px; font-weight: 500">
              {{
                isEnglish
                  ? "Please select estimate usage from the list on the left for calculation."
                  : "从左侧列表中选择对应的活动用量，轻松了解您的流量使用情况！"
              }}
            </div>
          </div>
          <div
            v-if="calculated"
            style="overflow-y: auto; height: 380px; position: relative; border-radius: 0"
          >
            <v-card-title
              class="pa-0 mx-0 mb-3 mt-5"
              style="font-size: 16px; font-weight: 600"
            >
              {{ isEnglish ? "Suggested eSIM data plans" : "最适合您的eSIM流量套餐" }}
            </v-card-title>

            <div
              style="overflow-y: auto; height: 280px; width: 98.6%; padding-right: 6px"
            >
              <v-card
                v-for="product in productList"
                :key="product.id"
                class="mx-auto rounded-lg d-flex flex-row align-center pa-4 mb-5"
                height="71"
                @click="onClick(product)"
                :style="
                  product.data == 5 && product.code && !leavingPage
                    ? 'border: 3px solid #80d4fc;'
                    : 'border: none;'
                "
                id="results-mobile"
              >
                <img :src="getFlagUrl(product.code)" class="mr-5 rounded-0" />
                <div class="d-flex flex-column">
                  <div class="pa-0 ma-0" style="font-size: 14px; font-weight: 500">
                    {{ product.data }} GB/{{ product.days }}
                    {{ isEnglish ? "Days" : "天" }}

                    <v-chip
                      v-if="product.data == 5 && !product.sale && product.code"
                      class="ml-2"
                      color="orange"
                      text-color="white"
                      size="x-large"
                      style="
                        height: 14px;
                        padding-left: 10px;
                        padding-right: 10px;
                        font-size: 10px;
                      "
                    >
                      {{ isEnglish ? "Best Value" : "热销中" }}
                    </v-chip>
                    <v-chip
                      v-else-if="product.sale"
                      color="red"
                      text-color="white"
                      style="
                        font-size: 10px;
                        font-weight: 500;
                        padding-left: 10px;
                        padding-right: 10px;
                        line-height: 150%;
                        height: 14px;
                      "
                      class="ml-4"
                    >
                      <span>
                        {{ isEnglish ? "Sale" : "折扣" }}
                      </span>
                    </v-chip>
                  </div>
                  <v-card-text
                    class="pa-0 ma-0"
                    v-if="product.code"
                    style="font-size: 10px"
                    >{{ product.name }}
                    {{ isEnglish ? "data" : "流量" }}
                  </v-card-text>
                  <v-card-text
                    class="pa-0 ma-0"
                    v-else
                    style="font-size: 10px; line-height: 20px"
                    >{{ product.name }}
                    {{ isEnglish ? "data" : "流量" }}
                    ·
                    {{ product.dests }}
                    {{ isEnglish ? "destinations" : "个目的地" }}
                  </v-card-text>
                </div>
                <div
                  style="margin-left: auto; text-align: right"
                  class="d-flex flex-column"
                >
                  <div
                    class="pa-0 ma-0"
                    v-if="!product.discount"
                    style="font-size: 13px; font-weight: 500"
                  >
                    ${{ product.price % 1 === 0 ? product.price + ".00" : product.price }}
                  </div>
                  <div v-else>
                    <div class="pa-0 ma-0" style="font-size: 13px; font-weight: 500">
                      ${{
                        product.discount % 1 === 0
                          ? product.discount + ".00"
                          : product.discount
                      }}
                    </div>
                    <v-card-text
                      class="pa-0 ma-0"
                      style="font-size: 12px; color: #909399"
                    >
                      <s
                        >${{
                          product.price % 1 === 0 ? product.price + ".00" : product.price
                        }}
                      </s></v-card-text
                    >
                  </div>
                </div>
                <img src="@/assets/rightArrow.svg" class="ml-0" />
              </v-card>
            </div>
            <div
              style="
                position: absolute;
                bottom: 0;
                right: 0;
                font-size: 10.7px;
                font-weight: 600;
                align-items: center;
                display: flex;
                flex-direction: row;
                cursor: pointer;
                font-family: Nunito;
                margin-top: 17px;
              "
              @click="onClick()"
            >
              {{ isEnglish ? "Explore more eSIM data plans" : "探索更多eSIM流量套餐" }}

              <img src="@/assets/rightArrowWhite.svg" />
            </div>
          </div>
        </v-card>
      </div> </v-main
  ></v-app>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      selectedItem: null,
      windowWidth: window.innerWidth,
      buttonEnable: false,
      items: null,
      popList: [],
      localList: [],
      regionList: [],
      search: "",
      defaultText: "Select/enter a destination",
      fullList: [],
      activities: [
        {
          key: 0,
          name: "Map/GPS navigation",
          iconSrc: "mapNav.svg",
          hours: 0,
        },
        { key: 1, name: "Social media", iconSrc: "socialMedia.svg", hours: 0 },
        {
          key: 2,
          name: "Streaming music",
          iconSrc: "streamMusic.svg",
          hours: 0,
        },
        {
          key: 3,
          name: "Internet browsing",
          iconSrc: "internetBrowsing.svg",
          hours: 0,
        },
        { key: 4, name: "Streaming video", iconSrc: "streamingVideo.svg", hours: 0 },
        { key: 5, name: "Video call", iconSrc: "videoCall.svg", hours: 0 },
      ],
      dailyData: 0.0,
      weeklyData: 0.0,
      monthlyData: 0.0,
      calculated: false,
      productList: [],
      isEnglish: true,
      leavingPage: false,
    };
  },
  name: "App",
  async mounted() {
    window.addEventListener("message", this.receiveMessage);
    // postMessage({ event: "zh" }, "*");
    // 1 second delay to ensure api calls correct language
    await new Promise((resolve) => setTimeout(resolve, 1000));

    // const port = "https://devapi-esim.textrapp.com";
    const port = "https://api-esim.textrapp.com";
    const url = `${port}/web/v1/getRegionList?webVersion=202306190756&countryCode=CA&clientTag=TextrESimWeb`;
    const response = await axios.get(url);
    this.items = response.data.result;
    var allCountries = "";
    var allCountriesAndRegions = "";
    this.popList.push({ code: "prepend", name: "Popular Destinations", disabled: true });
    for (let item of this.items.list) {
      let itemId = item._id;
      let itemDisplay = item.regionName.en;
      let itemDisplayZH = item.regionName.zh;
      let itemList = item.countryList;
      let itemName = "";
      let itemNameZH = "";
      let haveDiscount = item.haveDiscount;
      for (let country of itemList) {
        let countryId = country._id;
        let countryCode = country.code;
        let countryEN = country.name.en;
        let haveDiscount = country.haveDiscount;
        let countryZH = country.name.zh;
        itemName = itemName + " " + countryEN;
        itemNameZH = itemNameZH + " " + countryZH;
        allCountries = allCountries + " " + countryEN + " " + countryZH;

        this.localList.push({
          id: countryId,
          code: countryCode,
          name: this.isEnglish ? countryEN : countryZH,
          sale: haveDiscount,
          display: countryEN + " " + countryZH,
        });
        if (country.popular) {
          this.popList.push({
            id: countryId,
            code: countryCode,
            name: this.isEnglish ? countryEN : countryZH,
            sale: haveDiscount,
          });
        }
      }
      allCountriesAndRegions =
        allCountriesAndRegions + " " + itemDisplay + " " + itemDisplayZH;

      this.regionList.push({
        id: itemId,
        display: itemName + " " + itemNameZH + " " + itemDisplay + " " + itemDisplayZH,
        name: this.isEnglish ? itemDisplay : itemDisplayZH,
        sale: haveDiscount,
        countryTotal: itemList.length,
      });
    }

    allCountriesAndRegions += allCountries;

    this.fullList.push({ code: "prepend", name: allCountries, disabled: true });

    for (let item of this.localList) {
      this.fullList.push(item);
    }

    this.fullList.push({
      code: "divider",
      name: allCountriesAndRegions,
      disabled: true,
    });

    for (let item of this.regionList) {
      this.fullList.push(item);
    }
  },

  computed: {
    filteredItems() {
      if (!this.search) {
        return this.popList;
      }
      const keyword = this.search.toLowerCase();
      return this.fullList.filter((item) => this.customFilter(item, keyword));
    },
  },
  watch: {
    selectedItem: function (val) {
      if (typeof val === "object") {
        this.buttonEnable = true;
      } else {
        this.buttonEnable = false;
      }
    },
  },
  methods: {
    receiveMessage(event) {
      if (event.data && event.data.event === "zh") {
        this.isEnglish = false;
        this.defaultText = "选择/输入您的目的地";
        this.activities = [
          {
            key: 0,
            name: "地图/GPS 导航",
            iconSrc: "mapNav.svg",
            hours: 0,
          },
          { key: 1, name: "社交媒体应用", iconSrc: "socialMedia.svg", hours: 0 },
          {
            key: 2,
            name: "实时音乐",
            iconSrc: "streamMusic.svg",
            hours: 0,
          },
          {
            key: 3,
            name: "网页浏览",
            iconSrc: "internetBrowsing.svg",
            hours: 0,
          },
          { key: 4, name: "观看视频", iconSrc: "streamingVideo.svg", hours: 0 },
          { key: 5, name: "视频电话", iconSrc: "videoCall.svg", hours: 0 },
        ];
      } else if (event.data && event.data.event === "en") {
        this.isEnglish = true;
        this.defaultText = "Select/enter a destination";
        this.activities = [
          {
            key: 0,
            name: "Map/GPS navigation",
            iconSrc: "mapNav.svg",
            hours: 0,
          },
          { key: 1, name: "Social media", iconSrc: "socialMedia.svg", hours: 0 },
          {
            key: 2,
            name: "Streaming music",
            iconSrc: "streamMusic.svg",
            hours: 0,
          },
          {
            key: 3,
            name: "Internet browsing",
            iconSrc: "internetBrowsing.svg",
            hours: 0,
          },
          { key: 4, name: "Streaming video", iconSrc: "streamingVideo.svg", hours: 0 },
          { key: 5, name: "Video call", iconSrc: "videoCall.svg", hours: 0 },
        ];
      }
    },
    customFilter(item, queryText) {
      if (!queryText) {
        return true;
      }
      const textOne = item.name.toLowerCase();
      var textTwo = "null";
      if (item.display) {
        textTwo = item.display.toLowerCase();
      }
      if (queryText) {
        var searchText = queryText.toLowerCase();
      }
      return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1;
    },
    onClick(name) {
      if (name) {
        name = name.enName || name.name;
        if (name === "欧洲") {
          name = "Europe";
        } else if (name === "欧洲及中东地区") {
          name = "Europe + Middle East";
        } else if (name === "全球") {
          name = "Global";
        } else if (name === "亚太地区升级版") {
          name = "Asia-Pacific Plus";
        } else if (name === "亚太地区") {
          name = "Asia-Pac";
        } else if (name === "北美") {
          name = "North America";
        } else if (name === "美洲") {
          name = "Americas";
        }
        name = name.replace(/\s/g, "");
        name = name.charAt(0).toUpperCase() + name.slice(1);
        if (this.isEnglish) {
          window.parent.postMessage(
            { event: "clickLink", link: `https://esim.textrapp.com/plans/${name}` },
            "*"
          );
        } else {
          window.parent.postMessage(
            { event: "clickLink", link: `https://esim.textrapp.com/zh/plans/${name}` },
            "*"
          );
        }
      } else {
        if (this.isEnglish) {
          window.parent.postMessage(
            { event: "clickLink", link: `https://esim.textrapp.com/` },
            "*"
          );
        } else {
          window.parent.postMessage(
            { event: "clickLink", link: `https://esim.textrapp.com/zh` },
            "*"
          );
        }
      }
      this.leavingPage = true;
    },
    getImgUrl(pic) {
      return require(`@/assets/${pic}`);
    },
    getFlagUrl(pic) {
      if (!pic) {
        return require(`@/assets/countryFlag/regionFlag.svg`);
      }
      return require(`@/assets/countryFlag/${pic}.svg`);
    },
    decHrs(itemKey) {
      if (this.activities[itemKey].hours > 0) {
        this.activities[itemKey].hours -= 0.5;
      }
    },
    incHrs(itemKey) {
      if (this.activities[itemKey].hours < 24) {
        this.activities[itemKey].hours += 0.5;
      }
    },
    async calcData() {
      if (window.innerWidth < 768) {
        window.parent.postMessage({ event: "calcPressedMobile" }, "*");
      }
      this.dailyData =
        this.activities[0].hours * 0.004 +
        this.activities[1].hours * 0.244 +
        this.activities[2].hours * 0.674 +
        this.activities[3].hours * 0.009 +
        this.activities[4].hours * 0.244 +
        this.activities[5].hours * 0.82;
      this.weeklyData = this.dailyData * 7;
      this.monthlyData = this.dailyData * 30;
      const selectedId = this.selectedItem.id;
      // const port = "https://devapi-esim.textrapp.com";
      const port = "https://api-esim.textrapp.com";
      const url = `${port}/web/v1/getProductList?webVersion=202306190756&countryCode=CA&clientTag=TextrESimWeb&regionId=${selectedId}`;
      const response = await axios.get(url);
      const result = response.data.result;
      this.productList = [];
      for (let product of result.list) {
        this.productList.push({
          id: product.productId,
          code: product.countryCode,
          data: product.data,
          days: product.days,
          sale: product.haveDiscount,
          name: this.isEnglish
            ? product.regionOrCountryName.en
            : product.regionOrCountryName.zh,
          enName: product.regionOrCountryName.en,
          price: product.price,
          discount: product.discount,
          dests: this.selectedItem.countryTotal,
        });
      }
      if (this.productList[0].code) {
        for (let region of this.regionList) {
          if (region.display.indexOf(this.selectedItem.name) > -1) {
            let regionId = region.id;
            const regionUrl = `${port}/web/v1/getProductList?webVersion=202306190756&countryCode=CA&clientTag=TextrESimWeb&regionId=${regionId}`;
            const regionResponse = await axios.get(regionUrl);
            const regionResult = regionResponse.data.result;
            for (let product of regionResult.list) {
              this.productList.push({
                id: product.productId,
                code: product.countryCode,
                data: product.data,
                days: product.days,
                sale: product.haveDiscount,
                name: this.isEnglish
                  ? product.regionOrCountryName.en
                  : product.regionOrCountryName.zh,
                price: product.price,
                discount: product.discount,
                dests: region.countryTotal,
              });
            }
          }
        }
      }
      this.calculated = true;
    },
    updateInput(curVal) {
      console.log(curVal);
      if (typeof curVal === "string" || !curVal) {
        this.selectedItem = curVal;
      }
    },
    getIndex(item) {
      return this.fullList.indexOf(item);
    },
  },
};
</script>

<style lang="scss">
$body-font-family: "Pingfang SC", sans-serif;

.v-application {
  font-family: $body-font-family, sans-serif !important;
}

#calculator {
  display: flex;
  flex-direction: row;
}

.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #8e59ff !important;
}

#results .v-ripple__container {
  border: 3px solid #80d4fc !important;
}

#results-mobile .v-ripple__container {
  border: 3px solid #80d4fc !important;
}

@media screen and (min-width: 768px) {
  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #ebeef5;
  }
}

@media screen and (max-width: 768px) {
  ::-webkit-scrollbar {
    width: 3px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #ebeef5;
  }
}
</style>
